export default __webpack_public_path__ + "d008278952dd30fa56338b1f3dc546e4.png";